import { toast } from "sonner";

import { useProduct } from "@/api/products-query";
import { usePrivateAxios } from "@/api/use-private-axios";
import CreateProductForm from "@/components/store/product-form";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/store/edit/$productid")({
	component: RouteComponent
});

function RouteComponent() {
	const { productid } = Route.useParams();
	const { data: product, isPending, isError } = useProduct(productid);
	const privateAxios = usePrivateAxios();

	const createProductMutation = useMutation(
		{
			mutationKey: ["create-product"],
			mutationFn: async (data: FormData) => {
				const response = await privateAxios.post("/product/create_product", data, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				});
				return response.data;
			},
			onSuccess: () => {
				toast.success("Product created successfully");
			},
			onError: () => toast.error("Failed to create product")
		}
	);

	if (isPending) {
		return null;
	}
	if (isError) {
		return <div>Error</div>;
	}
	const defaultValues = {
		name: product.name,
		description: product.description,
		photos: product.photos.length > 0 ? product.photos[0] : "",
		price: product.price,
		quantity: product.quantity.toString(),
		status: product.status
	};

	return (
		<CreateProductForm
			{...defaultValues}
			isSuccess={createProductMutation.isSuccess}
			onSubmit={createProductMutation.mutateAsync}
		/>
	);
}
